import { useState } from "react";
import { useTool, Honeypot, Field, SubmitButton, ToolError, SoftCta } from "@/components/tools/ToolBits";

const BAND = { green: "text-[#5EE6D0]", yellow: "text-[#E9C98B]", red: "text-[#FF8A8A]" };

const Result = ({ d }) => (
  <div data-testid="seo-check-results" className="mt-8 rounded-2xl border border-white/10 bg-white/[0.03] p-5 sm:p-6">
    <div className="flex items-end gap-4">
      <span data-testid="seo-check-score" className={`font-display text-6xl leading-none ${BAND[d.band]}`}>{d.score}</span>
      <span className="pb-1 text-sm text-muted-foreground">/ 100 · rule-based, no AI</span>
    </div>
    <ul className="mt-6 space-y-3">
      {d.factors.map((f) => (
        <li key={f.key} data-testid={`seo-check-factor-${f.key}`} className="rounded-xl border border-white/10 bg-black/20 px-4 py-3">
          <div className="flex items-center justify-between text-sm"><span className="font-medium text-foreground">{f.label}</span><span className="font-mono text-muted-foreground">{f.points}/{f.max}</span></div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/10"><div className="h-full origin-left rounded-full bg-gradient-to-r from-[#8B7CFF] to-[#5EE6D0]" style={{ transform: `scaleX(${f.points / f.max})` }} /></div>
          <p className="mt-2 text-sm text-muted-foreground">{f.reason}</p>
        </li>
      ))}
    </ul>
    {d.fixes.length > 0 && (
      <div data-testid="seo-check-fixes" className="mt-6">
        <h3 className="font-display text-xl text-foreground">Fixes</h3>
        <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm text-muted-foreground marker:text-[#E9C98B]/70">{d.fixes.map((x) => <li key={x}>{x}</li>)}</ul>
      </div>
    )}
    <p className="mt-5 text-xs text-muted-foreground">Checks title guidance, the 13 tags and description depth. It can't see your attributes, photos or Etsy Stats.</p>
  </div>
);

export const SeoChecker = () => {
  const [f, setF] = useState({ title: "", tags: "", description: "" });
  const [state, run, trap] = useTool("/tools/seo-checker");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => { e.preventDefault(); run({ ...f, tags: f.tags.split(/[,\n]/).map((t) => t.trim()).filter(Boolean) }); };
  return (
    <div data-testid="seo-checker">
      <form onSubmit={submit} className="relative space-y-5">
        <Honeypot trap={trap} />
        <Field id="seo-check-title" label="Listing title" maxLength={300} value={f.title} onChange={set("title")} placeholder="Lavender Soy Candle in Amber Jar, 8 oz Hand Poured Aromatherapy Gift" />
        <Field id="seo-check-tags" label="Tags" hint="comma-separated" textarea maxLength={600} value={f.tags} onChange={set("tags")} placeholder="lavender candle, soy candle, amber jar candle, …" />
        <Field id="seo-check-description" label="Description" textarea maxLength={20000} value={f.description} onChange={set("description")} placeholder="Paste your listing description" />
        <SubmitButton busy={state.busy} label="Check my listing" testid="seo-check-submit" />
      </form>
      <ToolError state={state} />
      {state.data && <Result d={state.data} />}
      {state.data && <SoftCta />}
    </div>
  );
};
